import React, { useRef } from 'react'

import { HeadingLarge, BodyText, StatusText, ToggleIcon, Button } from '@pb/components'
import { formatDate, formatCurrency, useScrollTo } from '@pb/utils'
import cn from 'classnames'
import { path } from 'ramda'

import { PossibleOrderStatuses } from 'features/account/hm-pay/constants'
import getStatusType from 'helpers/getStatusType'

import { INVOICE_OPERATIONS } from '../../duck/constants'
import { trackSelectPaymentOption } from '../../tracking'
import styles from './MonthlyInvoiceCard.scss'

const MonthlyInvoiceCard: React.FC<any> = ({
  invoice,
  runKlarnaMonthlyInvoiceOperation,
  isExpanded,
}) => {
  const invoiceElement = useRef(null)

  const invoiceOperations: any = path(['payment_details', 'operations'], invoice)
  const payOperation = invoiceOperations.find(
    (operation: any) => operation.type === INVOICE_OPERATIONS.PAY,
  )

  /* eslint-disable @typescript-eslint/naming-convention */
  const {
    amount_left_to_pay = 0,
    total_amount = 0,
    status_description: statusDescription,
    due_date: dueDate,
    status,
  } = invoice.payment_details || {}
  /* eslint-enable @typescript-eslint/naming-convention */
  const formattedStartDate = formatDate(invoice.start_date)
  const formattedEndDate = formatDate(invoice.end_date)
  const formattedAmountToPay = formatCurrency(amount_left_to_pay / 100)
  const formattedTotalAmount = formatCurrency(total_amount / 100)
  const isPaid = status === PossibleOrderStatuses.PAID

  useScrollTo({ shouldScroll: isExpanded, ref: invoiceElement, delay: 300 })

  return (
    <div ref={invoiceElement} className={cn(styles.container, { [styles.isExpanded]: isExpanded })}>
      <ToggleIcon isExpanded={isExpanded} className={styles.toggleIcon} />
      <HeadingLarge className={styles.amount}>
        {isPaid ? formattedTotalAmount : formattedAmountToPay}
      </HeadingLarge>
      <BodyText
        className={styles.metaTextColor}
        marginless
      >{`${formattedStartDate} - ${formattedEndDate}`}</BodyText>
      <StatusText type={getStatusType(status, dueDate)} className={styles.statusText} icon>
        {statusDescription}
      </StatusText>
      {payOperation && (
        <Button
          size="large"
          fullWidth
          className={styles.payButton}
          onClick={(e) => {
            e.stopPropagation()
            trackSelectPaymentOption()
            runKlarnaMonthlyInvoiceOperation(payOperation.token, invoice.id)
          }}
        >
          {payOperation.label}
        </Button>
      )}
    </div>
  )
}

export default MonthlyInvoiceCard
